import clsx from "clsx";
import { motion } from "framer-motion";

import salesPlatformColumnLoading from "@assets/sales-v3-platform-loading-cell.gif";
import { type ColumnDef } from "@features/landing-page-analytics/types";

import { ROW_HEIGHT, SELECTION_COLUMN_WIDTH } from "../constants";
import { type LandingPageAnalyticsTableRow } from "../types";

import { CellLoadingIndictor } from "./cell-loading-indicator";

interface Props {
  columns: ColumnDef[];
  row: LandingPageAnalyticsTableRow;
}

export const TableRowLoading = ({ columns, row }: Props) => {
  return (
    <motion.tr
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={clsx(row.index % 2 === 0 ? "even" : "odd", "relative")}
      style={{
        height: ROW_HEIGHT,
      }}
    >
      <td className="sticky left-0 bg-white z-1 border-b border-gray-2"></td>
      <td
        className="sticky bg-white z-1 border-b border-gray-2"
        style={{ left: `${SELECTION_COLUMN_WIDTH}px` }}
      >
        <div className="flex items-center h-full ml-2">
          <img
            src={salesPlatformColumnLoading}
            alt="Loading table"
            style={{
              height: "2rem",
            }}
          />
        </div>
      </td>
      {Array.from({ length: columns.length - 1 }).map((_, i) => (
        <td key={i} className="border-b border-gray-2">
          <CellLoadingIndictor />
        </td>
      ))}
    </motion.tr>
  );
};
